import React from "react";
import PropTypes from 'prop-types';
import { NumericFormat } from 'react-number-format';

const NumberFormatDecimal = React.forwardRef(function NumberFormatDecimal(props, ref) {
  const { inputRef, onChange, ...numberFormatProps } = props;

  return (
    <NumericFormat
      {...numberFormatProps}
      getInputRef={ref || inputRef}
      onValueChange={(values) => {
        onChange({
          target: {
            value: values.value,
          },
        });
      }}
      thousandSeparator
      valueIsNumericString
      decimalScale={2}
      fixedDecimalScale={false}
    />
  );
});

NumberFormatDecimal.propTypes = {
  inputRef: PropTypes.any,
  onChange: PropTypes.func.isRequired
}

export default NumberFormatDecimal;
